import React from 'react'
import flowRight from 'lodash/flowRight'

import { ErrorView, Loading } from '@fielded/shared-ui'

import withConfig from '../../../../../van-shared/hoc/withConfig'
import { withApi } from '../../../../../common/ApiProvider'
import { withUser } from '../../../../../common/AuthenticationProvider'
import useShipments from '../hooks/useShipments'
import PSMStockTransfers from './PSMStockTransfers'

function PSMStockTransfersContainer ({
  api,
  user,
  config,
  history,
  showCompleted
}) {
  const statusToDisplay = showCompleted ? 'complete' : 'incomplete'

  const {error, locationName, shipments, loading} = useShipments({
    api, user, config, key: statusToDisplay, filters: shipment => shipment.planningType === 'interwarehouse' && shipment.statusType !== 'arrival'
  })

  if (error) {
    return <ErrorView title='Shipment' error={error} />
  }

  if (loading) {
    return <Loading loadingText='Loading completed shipments …' />
  }

  return (
    loading
      ? <div />
      : <PSMStockTransfers
        config={config}
        history={history}
        shipments={shipments}
        fullLocationName={locationName}
        showCompleted={showCompleted}
      />
  )
}

const withHOCs = flowRight(
  withApi,
  withUser,
  withConfig
)

export default withHOCs(PSMStockTransfersContainer)
